export const UPDATE_SIDEBAR_STATUS = 'UPDATE_SIDEBAR_STATUS'
export const SIDEBAR_STATUS = {
  SHOULD_REFRESH: 0,
  REFRESHING: 1,
  COMPLETE: 2
}
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'